
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/[[...pathParams]]",
      function () {
        return require("private-next-pages/help/[[...pathParams]]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/[[...pathParams]]"])
      });
    }
  